import { Box, Button, Modal } from "@mui/material"
import { useGetGroupsQuery } from "../groups/groupsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDuplicateTaskMutation } from "./tasksApiSlice"

const SelectGroup = () => {
    
    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    const [duplicateEvent, {isSuccess, data}] = useDuplicateTaskMutation()
    const [group, setGroup] = useState()
    const navigate = useNavigate()
    const {taskId, groupId, type} = useParams()
    useEffect(()=>{
        if(isSuccess){
            console.log(data)
            navigate(`/${type}/${group}/tasks/${data._id}`)
        }

    },[isSuccess])
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        navigate(`/${type}/${groupId}/tasks/${taskId}`)
      };
    const handleClick = () => {
        if(!group) {
            alert("please select group")
            return
        }
        duplicateEvent({id: taskId, group})
       
      };
    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })
  return (


    <Modal
    open={true}
    onClose={handleClose}
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
  >
    <Box sx={{ ...style, width: 400 }}>
    <label className="form__label form__checkbox-container" htmlFor="group1">
                    בחר קבוצה להעתקה:</label>
                <select
                    id="group1"
                    name="group"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={group}
                    onChange={(e)=>setGroup(e.target.value)}
                >
                    <option value="">---choose group---</option>
                    {options}
                </select>
                <div className="buttons-pan">
                <Button color="error" variant="contained" onClick={handleClose} >Close</Button>
                <Button variant="contained" onClick={handleClick} >Duplicate</Button>
              
                </div>
               
      
    </Box>
  </Modal>
  

  
  )
}

export default SelectGroup